import Vue from 'vue';

export function checkCCM19Consent() {
    /**
     * @note I moved Vue.config.devtools check here to simplify the high level code using this.
     */
    if (!window.CCM || Vue.config.devtools == true) return false;

    /**
     * @note @vlaja @jravas Check tomorrow to check what is happening here if partial consent is given and what is the value of these CCM object values.
     */
    return window.CCM.consent && window.CCM.fullConsentGiven;
}
